import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {MediaInterface} from '../../interfaces'

@Component({
  selector: 'dmmp-website-course-filter-image',
  templateUrl: './website-course-filter-image.component.html'
})
export class WebsiteCourseFilterImageComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  medias: MediaInterface[] = [
    {style: 'large', media: '(min-width:1301px)'},
    {style: 'max_1300x1300', media: '(min-width:651px) AND (max-width:1300px)'},
    {style: 'max_650x650', media: '(max-width:650px) AND (min-width:351px)'},
    {style: 'file_entity_browser_thumbnail', media: '(max-width:350px)'},
  ]
  constructor() {
  }

  ngOnInit(): void {
  }

}
